import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  sectionBox: {
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.grey[50],
    alignItems: 'center',
  },
  sectionTitle: {
    fontWeight: 600,
  },
  sectionSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
  },
}))

export default useStyles
